<template>
  <div class="text-center">
    <v-dialog
      v-model="canShowModal"
      max-width="500"
			persistent
      scrollable
    >
      <v-card>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <div class="d-flex flex-row align-center justify-space-between">
							<div class="d-flex flex-row align-center justify-start">
								<v-icon color="warning" class="mr-2">mdi-information</v-icon>
								<p class="mb-0 font-weight-bold text-primary body-1" v-if="modalData?.doc_type == 1">Contrato Existente</p>
								<p class="mb-0 font-weight-bold text-primary body-1" v-else-if="modalData?.doc_type == 2">Presupuesto Existente</p>
								<p class="mb-0 font-weight-bold text-primary body-1" v-else-if="modalData?.doc_type == 3">Informe Existente</p>
								<p class="mb-0 font-weight-bold text-primary body-1" v-else-if="modalData?.doc_type == 4">Presupuesto de Desarchivo Existente</p>
							</div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										small
										color="#959595"
										@click="closeModal"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark>mdi-close</v-icon>
									</v-btn>
								</template>
								<span>Cerrar</span>
							</v-tooltip>
						</div>
						<div class="mt-6 text-center" v-if="modalData?.doc_type == 1">
							<!-- Contrato -->
							<p class="mb-0">Ya existe un contrato para: <b>{{ projectName }}</b>.</p>
							<p>¿Deseas ir al detalle de este contrato?</p>
							<v-btn
								depressed
								dark
								color="#959595"
								@click="navigateToItem"
							>
								<v-icon dark>mdi-briefcase-outline</v-icon>
								<p class="ml-2 mb-0">Ir al Contrato</p>
							</v-btn>
						</div>
						<div class="mt-6 text-center" v-else-if="modalData?.doc_type == 2">
							<!-- Presupuesto -->
							<p class="mb-0">Ya existe un presupuesto (con el prefijo seleccionado) para: <b>{{ projectName }}</b>.</p>
							<p>¿Deseas ir al detalle de este presupuesto?</p>
							<v-btn
								depressed
								dark
								color="#959595"
								@click="navigateToItem"
							>
								<v-icon dark>mdi-briefcase-outline</v-icon>
								<p class="ml-2 mb-0">Ir al Presupuesto</p>
							</v-btn>
						</div>
						<div class="mt-6 text-center" v-else-if="modalData?.doc_type == 3">
							<!-- Informe -->
							<p class="mb-0">Ya existe un informe pendiente para esta línea de proyectos. Antes de crear otro por favor envía al cliente el informe pendiente.</p>
							<p>¿Deseas ir al detalle del informe pendiente?</p>
							<v-btn
								depressed
								dark
								color="#959595"
								@click="navigateToItem"
							>
								<v-icon dark>mdi-file-document-outline</v-icon>
								<p class="ml-2 mb-0">Ir al Informe</p>
							</v-btn>
						</div>
						<div class="mt-6 text-center" v-if="modalData?.doc_type == 4">
							<!-- Contrato -->
							<p class="mb-0">Ya existe un presupuesto de desarchivo abierto para: <b>{{ projectName }}</b>.</p>
							<p>¿Deseas ir al detalle de este presupuesto de desarchivo?</p>
							<v-btn
								depressed
								dark
								color="#959595"
								@click="navigateToItem"
							>
								<v-icon dark>mdi-file-document-outline</v-icon>
								<p class="ml-2 mb-0">Ir al Presupuesto de Desarchivo</p>
							</v-btn>
						</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'ExistentDocumentNotificationModal',
  data: () => ({
		indexModal: + new Date(),
  }),
  computed: {
		projectName(){
			if(this.modalData?.morphable?.name) return this.modalData?.morphable?.name
			else if(this.modalData?.morphable?.info?.project_detail) return this.modalData?.morphable?.info?.project_detail
			return ''
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		modalData() {
			return this.$store.state.general.existentDocumentNotificationModalData
		},
		canShowModal() {
			return this.$store.state.general.existentDocumentNotificationModal
			// const { existentContractNotificationModal } = this.$store.state.general;
			// if (!existentContractNotificationModal) return false;

			// if (this.modalData) {
			// 	const { contract_id, budget_id } = this.modalData;
			// 	const { ct, b } = this.$route.query;

			// 	if (contract_id && !b) return contract_id != ct;
			// 	if (budget_id && !ct) return budget_id != b;
			// 	return false
			// }

			// return false;
		}
	},
	watch: {
	},
  mounted(){
  },
  methods: {
		navigateToItem() {
			if(this.modalData?.doc_type == 1)
				this.$router.push({ name: 'ContractDetail', query: { id: this.modalData.id } })
			else if(this.modalData?.doc_type == 2)
				this.$router.push({ name: 'BudgetDetail', query: { id: this.modalData.id } })
			else if(this.modalData?.doc_type == 3)
				this.$router.push({ name: 'ReportDetail', query: { id: this.modalData.id } })
			else if(this.modalData?.doc_type == 4)
				this.$router.push({ name: 'ReportBudgetDetail', query: { id: this.modalData.id } })
			
			this.closeModal()
			//Cierra posible iniciador
			this.$store.commit('userrequests/setUserRequestModalId', null)
		},
		closeModal(){
			this.$store.commit('general/setExistentDocumentNotificationModal', false)
			this.$store.commit('general/setExistentDocumentNotificationModalData', null)
		}
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>